import { useCallback, useMemo } from 'react'

import { useFormikContext } from 'formik'
import { useSelector } from 'react-redux'

import { hasPermission } from '../../../../../utils'
import { ConstituentSelect } from '../../../../ui/select'

const ConstituentField = () => {
  const user = useSelector(state => state.auth.user)
  const { values, setFieldValue } = useFormikContext()

  const canSelectAny = hasPermission(user, 'casework.search_any_constituent')
  const onSelect = useCallback(
    option => setFieldValue('constituent', option),
    [setFieldValue, values.constituent]
  )
  const onClear = useCallback(
    () => setFieldValue('constituent', null),
    [setFieldValue]
  )

  const initialSelected = useMemo(
    () =>
      values?.constituent
        ? [
            {
              label: values.constituent.name,
              value: values.constituent,
            },
          ]
        : [],
    [values.constituent]
  )

  return (
    <ConstituentSelect
      onSelect={onSelect}
      onRemove={onClear}
      onClear={onClear}
      initialSelected={initialSelected}
      filters={{ district: canSelectAny ? values.district : undefined }}
      inputProps={{
        id: 'constituent-select',
        placeholder: 'Search for an existing constituent *',
      }}
    />
  )
}

export default ConstituentField
